import React from "react";
import { Label } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import "./steps.css";

export const statuses = {
  queued: "QUEUED",
  waiting_for_csv: "WAITING FOR CSV",
  file_migration: "MIGRATING A FILE",
  db_backup: "CREATING DB SNAPSHOT",
  emr_run: "EMR RUNNING",
  success: "SUCCESS",
  fail: "FAIL"
};

function getStepLabel(status) {
  switch (status) {
    case statuses.success:
      return <Label color="green" content="Success" icon="check" />;
    case statuses.fail:
      return <Label color="red" content="Failed" icon="x" />;
    case statuses.file_migration:
      return (
        <Label color="blue">
          <Icon name="spinner" loading />
          {`Migrating file FTP to AWS`}
        </Label>
      );
    case statuses.db_backup:
      return (
        <Label color="blue">
          <Icon name="spinner" loading />
          creating DB snapshot
        </Label>
      );
    case statuses.emr_run:
      return (
        <Label color="blue">
          <Icon name="spinner" loading />
          EMR running
        </Label>
      );
    case statuses.waiting_for_csv:
      return (
        <Label
          color="grey"
          content="Waiting for csv"
          icon="ellipsis horizontal"
        />
      );
    case statuses.queued:
      return (
        <Label color="blue">
          <Icon name="spinner" loading />
          Job queued
        </Label>
      );
    default:
      break;
  }
}

function Steps({ step, align = "none" }) {
  return (
    <div
      className={`c-label-progress ${
        align === "right" ? "c-label-progress-right" : ""
      }`}
    >
      <div className="label-progress">{getStepLabel(step)}</div>
    </div>
  );
}

export default Steps;



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/Steps/index.js